module.exports = __webpack_public_path__ + "蔡文胜-ab85913c.png";